
import { FC, useCallback, useRef, useState } from "react";
import { Context } from "./context";
import ConfirmModal from '../common/components/ConfirmModal'
import { useLocation } from "react-router-dom";

export const PromtContext: FC = ({ children }) => {
    const cbReject = useRef<() => void>();
    const cbResolve = useRef<() => void>();
    const [open, setOpen] = useState(false);

    const location = useLocation();

    const showPrompt = useCallback(
        () =>
            new Promise<void>((resolve, reject) => {
                cbReject.current = reject;
                cbResolve.current = resolve;
                setOpen(true);
            }),
        []
    );

    const close = useCallback(() => {
        if (cbReject.current) {
            cbReject.current();
        }
        setOpen(false);
    }, []);

    const confirm = useCallback(() => {
        if (cbResolve.current) {
            cbResolve.current();
        }
        setOpen(false);
    }, []);

    return (
        <Context.Provider value={showPrompt}>
            {children}
            {open ?
                <ConfirmModal
                    visible={open}
                    status="error"
                    onOk={() => {
                        confirm()
                    }}
                    onCancel={close}
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">
                            {location.pathname.includes("auction-register") ?
                                "Bạn có chắc chắn muốn thoát và không tiếp tục thực hiện gửi đăng ký bán tài sản?" :
                                "Bạn có chắc chắn muốn thoát và không lưu dữ liệu vừa nhập?"}
                        </div>
                    </div>}
                /> : <></>}
        </Context.Provider>
    );
};
